export const types = {
  OPEN_CONFIRM_QPV_PROCESS_MATERIAL_MODAL:
    'modules/quotePartViewer/modals/OPEN_CONFIRM_QPV_PROCESS_MATERIAL_MODAL',
  CLOSE_CONFIRM_QPV_PROCESS_MATERIAL_MODAL:
    'modules/quotePartViewer/modals/CLOSE_CONFIRM_QPV_PROCESS_MATERIAL_MODAL',
  CONFIRM_UPDATE_QPV_PROCESS_MATERIAL_REQUEST:
    'modules/quotePartViewer/modals/CONFIRM_UPDATE_QPV_PROCESS_MATERIAL_REQUEST',
  QPV_MATERIAL_MODAL_OPEN:
    'modules/quotePartViewer/modals/QPV_MATERIAL_MODAL_OPEN',
  QPV_MATERIAL_MODAL_CLOSE:
    'modules/quotePartViewer/modals/QPV_MATERIAL_MODAL_CLOSE',
  QPV_MATERIAL_MODAL_SAVE_REQUEST:
    'modules/quotePartViewer/modals/QPV_MATERIAL_MODAL_SAVE_REQUEST',
  QPV_MATERIAL_MODAL_SAVE_SUCCESS:
    'modules/quotePartViewer/modals/QPV_MATERIAL_MODAL_SAVE_SUCCESS',
  QPV_MATERIAL_MODAL_SAVE_ERROR:
    'modules/quotePartViewer/modals/QPV_MATERIAL_MODAL_SAVE_ERROR',
  UPDATE_QPV_SUPPLIER_MATERIAL_REQUEST:
    'modules/quotePartViewer/modals/UPDATE_QPV_SUPPLIER_MATERIAL_REQUEST',
  UPDATE_QPV_SUPPLIER_MATERIAL_SUCCESS:
    'modules/quotePartViewer/modals/UPDATE_QPV_SUPPLIER_MATERIAL_SUCCESS',
  UPDATE_QPV_SUPPLIER_MATERIAL_ERROR:
    'modules/quotePartViewer/modals/UPDATE_QPV_SUPPLIER_MATERIAL_ERROR',
  UPDATE_LOCAL_SUPPLIER_MATERIAL:
    'modules/quotePartViewer/modals/UPDATE_LOCAL_SUPPLIER_MATERIAL',
};

export const confirmModal = {
  open: ({ component }) => ({
    type: types.OPEN_CONFIRM_QPV_PROCESS_MATERIAL_MODAL,
    payload: { component },
  }),
  close: () => ({
    type: types.CLOSE_CONFIRM_QPV_PROCESS_MATERIAL_MODAL,
  }),
  updateProcessMaterial: ({
    componentId,
    processId,
    materialId,
    supplierMaterialId,
    shouldKeepExistingOperations,
  }) => ({
    type: types.CONFIRM_UPDATE_QPV_PROCESS_MATERIAL_REQUEST,
    payload: {
      componentId,
      processId,
      materialId,
      supplierMaterialId,
      shouldKeepExistingOperations,
    },
  }),
};

export const updateSupplierMaterial = {
  request: ({ materialId, supplierMaterial }) => ({
    type: types.UPDATE_QPV_SUPPLIER_MATERIAL_REQUEST,
    payload: { materialId, supplierMaterial },
  }),
  success: () => ({
    type: types.UPDATE_QPV_SUPPLIER_MATERIAL_SUCCESS,
  }),
  error: () => ({
    type: types.UPDATE_QPV_SUPPLIER_MATERIAL_ERROR,
  }),
};

export const materialModal = {
  open: ({ material, supplierMaterial }) => ({
    type: types.QPV_MATERIAL_MODAL_OPEN,
    payload: { material, supplierMaterial },
  }),
  close: () => ({
    type: types.QPV_MATERIAL_MODAL_CLOSE,
  }),
  save: {
    request: ({ materialId, data }) => ({
      type: types.QPV_MATERIAL_MODAL_SAVE_REQUEST,
      payload: { materialId, data },
    }),
    success: ({ supplierMaterial }) => ({
      type: types.QPV_MATERIAL_MODAL_SAVE_SUCCESS,
      payload: { supplierMaterial },
    }),
    error: () => ({
      type: types.QPV_MATERIAL_MODAL_SAVE_ERROR,
    }),
  },
};

export const updateLocalSupplierMaterial = ({ supplierMaterial }) => ({
  type: types.UPDATE_LOCAL_SUPPLIER_MATERIAL,
  payload: { supplierMaterial },
});
